import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";

const SingleClickButton = ({
  onClick,
  loadingText = "Processing...",
  cooldown = 1000,
  children,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const lastClickRef = useRef(null);
  const pendingRef = useRef(false);

  const handleClick = async () => {
    if (rest.disabled || pendingRef.current) return;

    const now = Date.now();
    if (lastClickRef.current !== null && now - lastClickRef.current < cooldown) {
      return;
    }
    lastClickRef.current = now;
    pendingRef.current = true;

    try {
      setLoading(true);
      await onClick();
    } finally {
      pendingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <Button {...rest} onClick={handleClick} disabled={loading || rest.disabled}>
      {loading ? loadingText : children}
    </Button>
  );
};

export default SingleClickButton;
